import React from "react";
import "./Header.css";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import { Link } from "react-router-dom";
import { useStateValue } from "./StateProvider";
import { auth } from "./firebase";
import ReactCountryFlag from "react-country-flag";
import HomeIcon from '@material-ui/icons/Home';

function Header() {
  const [{ basket, user }, dispatch] = useStateValue();

  const handleAuthentication = () => {
    if (user) {
      auth.signOut();
    }
  };

  return (
    <div className="header">
      <Link to="/">
        {/* <img
          className="header__logo"
          // src="http://pngimg.com/uploads/amazon/amazon_PNG11.png"
        /> */}
        <HomeIcon className="header__logo"></HomeIcon>
      </Link>

      <div className="header__search">
        <input className="header__searchInput" type="text" />
        <SearchIcon className="header__searchIcon" />
      </div>
      <div className="header__option">
        <ReactCountryFlag
          countryCode="IN"
          svg
          style={{
            width: "2em",
            height: "2em",
          }}
          title="US"
        />
      </div>

      <div className="header__nav">
        <Link to={!user && "/login"}>
          <div onClick={handleAuthentication} className="header__option">
            <span className="header__optionLineOne">
              Hello {user ? user?.email : "Guest"}
            </span>
            <span className="header__optionLineTwo">
              {user ? "Sign Out" : "Sign In"}
            </span>
          </div>
        </Link>
        <Link to="/order">
          <div className="header__option">
            <span className="header__optionLineOne">Returns</span>
            <span className="header__optionLineTwo">& Orders</span>
          </div>
        </Link>

        <Link to="/contact">
          <div className="header__option">
            <span className="header__optionLineOne">Our</span>
            <span className="header__optionLineTwo">Contact</span>
          </div>
        </Link>
        <Link to="/Checkout">
          <div className="header__optionBasket">
            <ShoppingBasketIcon />
            <span className="header__optionLineTwo header__basketCount">
              {user ? basket?.length : 0}
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Header;
